import { useMutation } from "@tanstack/react-query";
import orbitService from "../../../services/orbit-service";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  getOrbitParamPayload,
  orbitParamValue,
  setQueryParams,
} from "../../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { getAuthDetails } from "../../../../../feature/auth-slice";
import {
  getOrbitDetails,
  setHeader,
  setInstriction,
  setMaps,
  setOrbitAccess,
} from "../../../../../feature/orbit-slice";
import SySolarSystem from "../../../../../shared/components/sy-solar-system";
import styleSheet from "../style.module.scss";
import OrbitManage from "../orbit-manage";
import SyIcon from "../../../../../shared/components/sy-icon";
import Instriction from "../../../components/instrictions";
import OrbMap from "../../../../../shared/components/orb-map";
import OrbitHoverDetails from "../orbit-hover-details";
import { useTranslation } from "react-i18next";
import { setCookie } from "../../../../../utils/cookie";
import SplashInfoPop from "../../../popups/splash-info-popup";
import SyPopup from "../../../../../shared/components/sy-model";
import PlanetListPop from "../../../popups/planet-list-popup";

const OrbitDetails = (props: any) => {
  const { navPlanetDetails } = props;
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<any>(orbitParamValue(searchParams));
  const authSlice = useSelector(getAuthDetails);
  const orbitSlice = useSelector(getOrbitDetails);
  const [orbitData, setOrbitData] = useState<any>(null);
  const [openInfoPop, setOpenInfoPop] = useState<any>(false);
  const [mapData, setMapData] = useState([]);
   const [openPlanetList, setOpenPlanetList] = useState(false);
     const [planetListDetails, setPlanetListDetails] = useState([]);
  const dispatch = useDispatch();
  const [planetHoverDetails, setPlanetHoverDetails] = useState<any>({});
  const { t } = useTranslation();

  const { mutate: getOrbitList, isPending: orbitLoading } = useMutation({
    mutationFn: orbitService.orbit,
    onSuccess(data, variables, context) {
      setOrbitData(data.data);
      // dispatch(setInstriction(data.data.step_status))
      dispatch(setOrbitAccess(data.data.orb_access_type));
      setMapData(getMapData(data.data));
      setPlanetHoverDetails(null);
    },
  });

  const { mutate: getOrbitDetail, isPending: getOrbitLoading } = useMutation({
    mutationFn: orbitService.getOrbit,
    onSuccess(data, variables, context) {
      setOrbitData(data.data);
      // dispatch(setInstriction(data.data.step_status))
      dispatch(setOrbitAccess(data.data.orb_access_type));
      setMapData(getMapData(data.data));
      setPlanetHoverDetails(null);
    },
  });


  const getMapData = (val: any) => {
    const address = val.planets.map((data: any) => {
      const add = {
        orb_id: val.orb_id,
        id: data.pro_cat_1,
        address: data.pro_address,
        hover: false,
        pro_id: data.pro_id,
      };

      return add;
    });
    return address;
  };
  const orbitList = () => {
    const payload = {
      orb_id: orbitSlice.selectOrbit,
      usr_id: authSlice.user_details.usr_id,
    };
    getOrbitList(payload);
  };

  const orbitDetails = () => {

    const payload = {
      orb_id: orbitSlice.selectOrbit,
      usr_id: authSlice.user_details.usr_id,
    };
    getOrbitDetail(payload);
    // if (authSlice.authToken) {
    //   getOrbitDetail(orbitSlice.selectOrbit);
    // } else {
    //   getAuthOrbitDetail(orbitSlice.selectOrbit);
    // }
  };

  useEffect(() => {
    updateOrbitDetails();
  }, [orbitSlice.selectOrbit]);

  const updateOrbitDetails = () => {
    if (params.fr === "home") {
      orbitList();
    } else {
      orbitDetails();
    }
  };

  const planetOnclick = (data: any) => {

    if(data?.children?.length){
onClickPlanetList(data?.children)
    }else{
     navPlanetDetails(orbitSlice.selectOrbit, data.pro_id);
    }
   
  };

  const onClickPlanetList =(data:any)=>{
    console.log(data,'data')
setOpenPlanetList(true)
setPlanetListDetails(data)
console.log(planetListDetails,'planetListDetails')
  }

  const onChangeMaps = () => {
    const value = orbitSlice.maps === 1 ? 0 : 1;

    dispatch(setMaps(value));
    setQueryParams(
      getOrbitParamPayload(orbitSlice.selectOrbit, value, params.fr)
    );
  };

  const planetHover = (data: any, type: any) => {
    if (type === "in") {
      setPlanetHoverDetails(data);
      const updatedMapData: any = mapData?.map((val: any) => ({
        ...val,
        hover: val.pro_id === data.pro_id,
      }));
      setMapData(updatedMapData);
    } else {
      setPlanetHoverDetails(null);
    }
  };

  // useEffect(() => {
  //   if (!orbitData.step_status) {
  //     if (orbitData.orb_id) {
  //       dispatch(setHeader(false));
  //     }
  //   } else {
  //     dispatch(setHeader(true));
  //   }
  // }, [orbitData]);

  const openInfo = () => {
    setOpenInfoPop(true);
  };
  const closeInfoPop = () => {
    setOpenInfoPop(false);
  };
  const closePlanetListData  = () => {
    setOpenPlanetList(false);
  }

  return (
    <>
      {
        orbitData && (
          <div className="row p-2 pt-3  ">
            <div className={` ${orbitSlice.maps ? "col-12" : "col-lg-3 col-sm-12"}`}>
              <OrbitManage
                orbitData={orbitData}
                updateOrbitDetails={updateOrbitDetails}
              />
            </div>
            <div
              className={`${
                !orbitSlice.maps
                  ? `${styleSheet.orbit} col-6 mt-1  `
                  : `${styleSheet.orbitMap} col-4`
              }  position-relative `}
            >
              <SySolarSystem
                layout={orbitData?.planets ? orbitData?.planets : []}
                planetOnclick={planetOnclick}
                planetHover={planetHover}
                // mask={orbitData?.step_status ? true :false}
              />
            </div>
            <div className={`${orbitSlice.maps ? "col" : "col"} mt-2`}>
              <OrbitHoverDetails planetHoverDetails={planetHoverDetails} />
            </div>

            {orbitSlice.maps ? (
              <div className={`col-lg-5 col-md-10 mt-2`}>
                <OrbMap locations={mapData} />
              </div>
            ) : null}

            <div className={` col-lg-12   mb-5 ${orbitSlice.maps?"mt-5":""}`}>
              <div
                className="d-flex justify-content-between"
                
              >
                <div className="d-flex" onClick={openInfo}>
                  <SyIcon
                    name={"contact_support"}
                    iconColor="rgba(255, 255, 255, 0.3)"
                    size="sm"
                    className={`pointer pt-2 `}
                  />
                  <p className="text-white ms-1 bebas-neue m-0 mt-2">
                    {t("info")}
                  </p>
                </div>
                <div className="d-flex" onClick={onChangeMaps}>
                  <SyIcon
                    name={"trending_flat"}
                    iconColor="rgba(255, 255, 255, 0.3)"
                    size="md"
                    className={`${
                      !orbitSlice.maps ? styleSheet.rotate : ""
                    }  pointer  `}
                  />
                  <p className="text-white ms-1 bebas-neue m-0 mt-2">
                    {t("maps")}
                  </p>
                </div>
              </div>
            </div>
            <SyPopup open={openInfoPop} onClose={closeInfoPop} maxWidth={"sm"}>
              <SplashInfoPop handleCloseClick={closeInfoPop} />
            </SyPopup>
                <SyPopup open={openPlanetList} onClose={closePlanetListData} maxWidth={"md"}>
              <PlanetListPop  onClose={closePlanetListData} planetData={planetListDetails}/>
            </SyPopup>

            {/*             
            <div className="col">
              <div className="row">
                <div className={`${orbitSlice.maps ? "col-4" : "col"}`}>
                  <OrbitHoverDetails planetHoverDetails={planetHoverDetails} />
                </div>
                {orbitSlice.maps ?
                <div className={`col-lg-8  `}>
                  <OrbMap locations={mapData} />
                </div>:null}
              </div>
            </div> */}

            {/* <div className="row  " onClick={onChangeMaps}>
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <SyIcon
                    name={"contact_support"}
                    iconColor="rgba(255, 255, 255, 0.3)"
                    size="sm"
                    className={`  pointer pt-2  `}
                  />
                  <p className="text-white ms-1 bebas-neue m-0 mt-2">
                    {t("info")}
                  </p>
                </div>
                <div className="d-flex">
                  <SyIcon
                    name={"trending_flat"}
                    iconColor="rgba(255, 255, 255, 0.3)"
                    size="md"
                    className={`${
                      !orbitSlice.maps ? styleSheet.rotate : ""
                    }  pointer  `}
                  />
                  <p className="text-white ms-1 bebas-neue m-0 mt-2">
                    {t("maps")}
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        )

        // <div className="row p-2 pt-3">
        //   <div className={` ${orbitSlice.maps ? `col-12` : `col-3 mt-5`} ps-3`}>
        //     <OrbitManage
        //       orbitData={orbitData}
        //       updateOrbitDetails={updateOrbitDetails}
        //     />
        //   </div>
        //   <div
        //     className={`${
        //       !orbitSlice.maps
        //         ? `${styleSheet.orbit} col-6 mt-5 ${styleSheet.details_animate} `
        //         : `${styleSheet.orbit2} col-4 ${styleSheet.hover_details_animate}`
        //     } ms-5  position-relative `}
        //   >
        //     <SySolarSystem
        //       layout={orbitData?.planets ? orbitData?.planets : []}
        //       planetOnclick={planetOnclick}
        //       planetHover={planetHover}
        //       mask={orbitData?.step_status ? true :false}
        //     />

        //   </div>
        //   {orbitSlice.maps  ? (
        //     <div className={`col-2  ${styleSheet.hover_details_animate}`}>
        //       <OrbitHoverDetails planetHoverDetails={planetHoverDetails} />
        //     </div>
        //   ):null}
        //   {orbitSlice.maps ? (
        //     <div className={`col-5  ${styleSheet.hover_details_animate}`}>
        //       <OrbMap locations={mapData}  />
        //     </div>
        //   ):null}
        //   <div className="col-3 ">

        //     {!orbitSlice.maps ? (
        //       <OrbitHoverDetails planetHoverDetails={planetHoverDetails} />
        //     ):null}

        //       <div
        //         className="d-flex position-absolute bottom-0 end-0 pe-3 pb-3 "
        //         onClick={onChangeMaps}
        //       >
        //         <div className="d-flex">
        //         <SyIcon
        //           name={"trending_flat"}
        //           iconColor="rgba(255, 255, 255, 0.3)"
        //           size="md"
        //           className={`${
        //             !orbitSlice.maps ? styleSheet.rotate : ""
        //           }  pointer  `}
        //         />
        //         <p className="text-white ms-1 bebas-neue m-0 mt-2">{t('maps')}</p>
        //         </div>

        //       </div>
        //   </div>
        // </div>
      }
    </>
  );
};

export default OrbitDetails;
